import { NativeBridge } from "@swiggy-private/native-bridge";

export const closeWebView = (sdk: NativeBridge) => {
    return sdk?.close();
};

// eslint-disable-next-line max-params
export const webNavigate = (sdk: NativeBridge, url: string, openAsExternal: boolean, showBack?: boolean) => {
    return sdk?.webNavigate({
        url,
        openAsExternal,
        showBack: showBack ?? false,
        showLoader: true,
        callbackUrl: window.location.href,
        title: "Swiggy money",
    });
};

export const launchBrowser = (sdk: NativeBridge, url: string) => {
    return sdk?.launchBrowser({
        url,
    });
};

export const getSwiggyHeadersFromNB = (sdk: NativeBridge) => {
    return sdk?.getSwiggyHeadersDataFromClient();
};

export const getDynamicFlags = (sdk: NativeBridge) => {
    return sdk
        ?.getConfigValue({
            wpKeyList: ["web_gzip_analytics_message"],
            xpKeyList: [],
        })
        .catch(() => void 0);
};

export const hideNativeHeader = (sdk: NativeBridge): void => {
    sdk?.showHeader({ show: false, title: "" }).catch(() => void 0);
};
